module.exports = __webpack_public_path__ + "ada074658b6e377797e87c89efb06ff3.svg";